import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class ElementDto extends BaseEntityDto {
  name: string;

  toString(): string {
    return this.name;
  }
}
